import React, { useState } from "react";
import { observer } from "mobx-react";
import { ISaleDetailVMList } from "../../../models/response/ITotallingManagementResponse";
import { CellContext } from "@tanstack/react-table";
import { ColumnType } from "../../../constants/enums/grid-column-type-enum";
import { showAmountWithFormatting } from "../../../helpers/common-component-helper";
import { IInventoryVM } from "../../../models/response/IInventoryManagementResponse";
import Grid, { getColumns } from "../../../shared-components/Grid/Grid";
import { ISorting } from "../../../models/ISorting";

interface IProps {
  data: ISaleDetailVMList[];
}

const WeeklySalesDetail: React.FC<IProps> = ({ data }) => {
  const [sorting, setSorting] = useState<ISorting>({
      column: "product_name",
      orderBy: "asc",
    });
  
    const handleSortingChange = (accessor: string) => {
      let sortOrder = sorting.orderBy;
      if (accessor === sorting.column) {
        sortOrder = sorting.orderBy === "asc" ? "desc" : "asc";
      }
      setSorting({ column: accessor, orderBy: sortOrder });
    };
const columArray: any = [
    {
      columnType: ColumnType.Hidden,
      accessorKey: "Id",
    },
    {
      columnType: ColumnType.TextHeader,
      accessorKey: "Date",
      displayName: "date",
    },
    {
      columnType: ColumnType.JsxElement,
      accessorKey: "TotalSales",
      displayName: "total_sales",
      jsxElementFormatter: (info: CellContext<any, any>) => {
        let cell = info.getValue();
        return cell !== "" ? showAmountWithFormatting(cell) : ""
      },
    },
    {
      columnType: ColumnType.JsxElement,
      accessorKey: "TreatmentSales",
      displayName: "treatment_sales",
      jsxElementFormatter: (info: CellContext<any, any>) => {
        let cell = info.getValue();
        return cell !== "" ? showAmountWithFormatting(cell) : ""
      },
    }, 
    {
      columnType: ColumnType.JsxElement,
      accessorKey: "ProductSales",
      displayName: "product_sales",
      jsxElementFormatter: (info: CellContext<any, any>) => {
        let cell = info.getValue();
        return cell !== "" ? showAmountWithFormatting(cell) : ""
      },
    },
    {
      columnType: ColumnType.JsxElement,
      accessorKey: "DiscountTreatment",
      displayName: "treatment_discount",
      jsxElementFormatter: (info: CellContext<any, any>) => {
        let cell = info.getValue();
        return cell !== "" ? showAmountWithFormatting(cell) : ""
      },
    },
    {
      columnType: ColumnType.JsxElement,
      accessorKey: "DiscountProduct",
      displayName: "product_discount",
      jsxElementFormatter: (info: CellContext<any, any>) => {
        let cell = info.getValue();
        return cell !== "" ? showAmountWithFormatting(cell) : ""
      },
    },
    {
      columnType: ColumnType.TextHeader,
      accessorKey: "TotalNumberOfCustomer",
      displayName: "number_of_customers",
    },
  ];
  const columns = getColumns<IInventoryVM, number>(
    columArray,
    sorting,
    handleSortingChange
  );

  return (
    <div className="table-responsive all-day-table">
      {data && (
        <Grid
          data={data}
          columns={columns}
          isInProgress={false}
          hiddenColumns={["Id"]}
        />
      )}
    </div>
  );
};

export default observer(WeeklySalesDetail);
